<script>
export default {
  name: 'TogglePreviewButton',
  props: {
    value: Boolean
  },
  methods: {
    handleButtonClick () {
      this.$emit('input')
    }
  }
}
</script>

<template>
  <b-button class="button toggle-preview-button" @click.prevent="handleButtonClick">
    {{ value ? 'Hide Preview' : 'Show Preview' }}
  </b-button>
</template>

<style scoped lang="scss">
.toggle-preview-button {
  gap: 18px;
}
</style>
